export const iconFontAwesomeMedicalHealthLungs = (
	<i className="fa-solid fa-lungs"></i>
);
